import { createI18n } from 'vue-i18n';
import en from './locales/en';
import ru from './locales/ru';
import type { App } from 'vue';

export type AvaliableLocales = keyof typeof messages;

const messages = {
  en,
  ru,
}

const VueI18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  legacy: false,
  warnHtmlMessage: false,
  globalInjection: true,
  runtimeOnly: false,
  messages,
  pluralRules: {
    'ru': function(choice, choicesLength) {
      if (choice === 0) {
        return 0;
      }

      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;

      if (choicesLength < 4) {
        return (!teen && endsWithOne) ? 1 : 2;
      }
      if (!teen && endsWithOne) {
        return 1;
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }

      return (choicesLength < 4) ? 2 : 3;
    },
  },
});

export function I18nSetup(app: App<Element>) {
  app.use(VueI18n);
} 

export default VueI18n;
